var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9823 1.76278C10.631 1.48953 10.4553 1.3529 10.2613 1.30038C10.0902 1.25404 9.9098 1.25404 9.73865 1.30038C9.54468 1.3529 9.36902 1.48953 9.0177 1.76278L2.23539 7.0379C1.78202 7.39052 1.55534 7.56683 1.39203 7.78764C1.24737 7.98322 1.1396 8.20356 1.07403 8.43783C1 8.7023 1 8.98948 1 9.56383V16.7988C1 17.9189 1 18.4789 1.21799 18.9067C1.40973 19.2831 1.71569 19.589 2.09202 19.7808C2.51984 19.9988 3.0799 19.9988 4.2 19.9988H6.2C6.48003 19.9988 6.62004 19.9988 6.727 19.9443C6.82108 19.8963 6.89757 19.8198 6.9455 19.7258C7 19.6188 7 19.4788 7 19.1988V12.5988C7 12.0387 7 11.7587 7.10899 11.5448C7.20487 11.3566 7.35785 11.2036 7.54601 11.1078C7.75992 10.9988 8.03995 10.9988 8.6 10.9988H11.4C11.9601 10.9988 12.2401 10.9988 12.454 11.1078C12.6422 11.2036 12.7951 11.3566 12.891 11.5448C13 11.7587 13 12.0387 13 12.5988V19.1988C13 19.4788 13 19.6188 13.0545 19.7258C13.1024 19.8198 13.1789 19.8963 13.273 19.9443C13.38 19.9988 13.52 19.9988 13.8 19.9988H15.8C16.9201 19.9988 17.4802 19.9988 17.908 19.7808C18.2843 19.589 18.5903 19.2831 18.782 18.9067C19 18.4789 19 17.9189 19 16.7988V9.56383C19 8.98948 19 8.7023 18.926 8.43783C18.8604 8.20356 18.7526 7.98322 18.608 7.78764C18.4447 7.56683 18.218 7.39052 17.7646 7.03791L10.9823 1.76278Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.eb29b667f92db8d71658f2d82003fd44.svg";
export { ForwardRef as ReactComponent };